import { render } from "./StockColis.vue?vue&type=template&id=26b290ff&ts=true"
import script from "./StockColis.vue?vue&type=script&lang=ts"
export * from "./StockColis.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__